module.exports = __webpack_public_path__ + "static/media/xata.a3c95911.png";